import { Report } from '../reports/components/report/models/report.model';

export class UserPermissionReport {
  Id: number;
  UserId: number;
  UserDescription: string;
  UserEmail: string;
  UserLogin: string;
  Report: Report;
  ObjectId: number;
  ObjectPublicId: number;
  ObjectSharedId: number;
}
